import React, {Component} from 'react';

class TabHeader extends Component {
  render() {
    const tabclass = this.props.isActive ? 'nav-tab nav-tab-active' : 'nav-tab';

    const enabled = this.props.tab.enabled || (this.props.tab.title === 'Default Fields Filter' || this.props.tab.title === 'Ordering' || this.props.tab.title === 'Limit and Offset' || this.props.tab.title === 'Output' );

    let style = {};

    if (!enabled) {
      style = {
        opacity: 0.5
      }
    }

    return <div style={style} onClick={ () => enabled && this.props.onTabHeaderClick(this.props.tabIndex)} className={tabclass}>{this.props.tab.title} {this.props.tab.icon}</div>;
  }
}

export default TabHeader;
